import { memo } from 'react';
import { Dialog } from 'react-aria-components';

import { Modal, ModalOverlay } from '@/components/core';

import { AddOrEditRole, AddOrEditRoleProps } from './AddOrEditRole.tsx';

export type AddOrEditRoleModalProps = AddOrEditRoleProps;

// eslint-disable-next-line no-empty-pattern
const IAddOrEditRoleModal = ({ ...rest }: AddOrEditRoleModalProps) => {
  return (
    <ModalOverlay>
      <Modal>
        <Dialog className="outline-none">
          {({ close }) => <AddOrEditRole className="p-md w-[25rem]" close={close} {...rest} />}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const AddOrEditRoleModal = memo(IAddOrEditRoleModal) as typeof IAddOrEditRoleModal;
